<template>
  <v-layout class="exit-confirmation div-center-horizontally">
    <v-flex xs12 sm12>
      <v-container class="medium-div">
        <v-layout row class="header-row">
          <v-flex xs12 sm12 class="div-center-vertically div-right-horizontally">
            <v-btn icon @click="">
              <v-icon @click="cancelExit" class="close-icon">close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-row class="confirm-exit-row" justify="center">
          <v-col cols="12" class="confirm-exit-col">
            <p class="card-title-text">{{$t('ExitConfirmation.title')}}</p>
            <p class="card-subtitle-text">{{$t('ExitConfirmation.subtitle')}}</p>
            <v-btn @click="cancelExit" class="confirmation-btn mt-5 mr-5">{{$t('ExitConfirmation.no')}}</v-btn><v-btn @click="confirmExit" class="confirmation-btn mt-5 ml-5">{{$t('ExitConfirmation.yes')}}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    props: {
      exitConfirmationDialog: {
        type: Boolean,
        required: true
      },
      backTo: {
        type: Object,
        required: false
      }
    },
    methods: {
      cancelExit () {
        this.$emit('update:exitConfirmationDialog', false)
      },
      confirmExit () {
        if (this.backTo) {
          this.$router.push(this.backTo)
        } else {
          this.$router.push({name: 'OrganizationHome'})
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ExitConfirmation.vue?617f0d4e